<template>
  <div class="printed">
    <v-card outlined style="overflow-y: auto;">
      <v-card-text>
        <v-row>
            <v-col cols="8" sm="4" md="8">
                <h2 style="font-family: 'Arial'">Ringkasan Order</h2>
                <h4 style="font-family: 'Arial'">#{{dataDetails.name}}</h4>
            </v-col>
            <v-col cols="4" sm="2" md="4">
                <p class="font-weight-bold text-right mb-0">{{dataUser.company == undefined ? 'Tidak ada nama' : dataUser.company.name}}</p>
                <p class="text-right mb-0">{{dataUser.company == undefined ? 'Tidak ada alamat' : dataUser.company.email}}</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-4">
            <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
              <p class="font-weight-bold">Nama Cashier:</p>
            <!-- <p class="font-weight-bold">Nama Customer:</p> -->
            </v-col>
            <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
              <p class="text-left">{{dataDetails.user == null ? 'Tidak ada nama petugas' : dataDetails.user.name}}</p>
            <!-- <p class="text-left">{{dataDetails.customer == null ? 'Tidak ada nama customer' : dataDetails.customer.name}}</p> -->
            </v-col>
            <v-col cols="4" sm="2" md="4" class="text-center pa-0">
            <template v-if="dataDetails.status == 'PAID'">
                <v-chip
                class="mb-2"
                color="green"
                label
                outlined
                >
                <v-icon left>monetization_on</v-icon>
                {{dataDetails.status}}
                </v-chip>
            </template>
            <template v-else-if="dataDetails.status == 'PARTIAL'">
                <v-chip
                class="mb-2"
                color="blue"
                label
                outlined
                >
                <v-icon left>monetization_on</v-icon>
                {{dataDetails.status}}
                </v-chip>
            </template>
            <template v-else-if="dataDetails.status == 'APPROVED'">
                <v-chip
                class="mb-2"
                color="orange"
                label
                outlined
                >
                <v-icon left>monetization_on</v-icon>
                UNPAID
                </v-chip>
            </template>
            <template v-else-if="dataDetails.status == 'REJECTED'">
                <v-chip
                class="mb-2"
                color="red darken-2"
                label
                outlined
                >
                <v-icon left>cancel</v-icon>
                {{dataDetails.status}}
                </v-chip>
            </template>
            <template v-else-if="dataDetails.status == 'COMPLETED'">
                <v-chip
                class="mb-2"
                color="green"
                label
                outlined
                >
                <v-icon left>check_box</v-icon>
                {{dataDetails.status}}
                </v-chip>
            </template>
            </v-col>
            <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
              <p class="font-weight-bold">Jumlah Pesanan:</p>
            <!-- <p class="font-weight-bold">Nama Cashier:</p> -->
            </v-col>
            <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
            <!-- <p class="text-right">{{dataDetails.user == null ? 'Tidak ada nama petugas' : dataDetails.user.name}}</p> -->
              <p class="text-right">{{dataDetails.items.length}}</p>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
            <!-- <p class="font-weight-bold">Telepon Customer:</p> -->
              <p class="font-weight-bold">Tanggal Order:</p>
            </v-col>
            <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
              <p class="text-left">{{dataDetails.date}}</p>
            <!-- <p class="text-left">{{dataDetails.customer == null ? 'Tidak ada telepon customer' : dataDetails.customer.telp == null ? 'Tidak ada telepon customer' : dataDetails.customer.telp}}</p> -->
            </v-col>
            <v-col cols="4" sm="2" md="4" class="text-center">
            </v-col>
            <v-col class="pa-0 pl-3" cols="2" sm="1" md="2">
            <p class="font-weight-bold">Order Number:</p>
            </v-col>
            <v-col class="pa-0 pr-3" cols="2" sm="1" md="2">
            <p class="text-right">{{dataDetails.id}}</p>
            </v-col>
        </v-row>
        <v-simple-table fixed-header max-height="300px" class="mt-4">
          <template>
            <thead class="grey lighten-4">
                <tr>
                <td v-for="header in headerSubItem" :key="header.text" :class="header.align">{{ header.text }}</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(subItem, index) in dataDetails.items" :key="subItem.id">
                <td class="text-left"><b>{{ index+1 }}.</b></td>
                <td class="text-left" v-if="subItem.schedule"><b>{{ subItem.item_name }}</b> <br/> Mulai: {{ subItem.schedule.start.substring(0, 16) }} <br/> Selesai: {{ subItem.schedule.finish.substring(0, 16) }} </td>
                <td class="text-left" v-else>{{ subItem.item_name }}</td>
                <td class="text-center" v-if="subItem.schedule">{{ Number(subItem.qty) % 1 == 0 ? Number(subItem.qty) : Number(subItem.qty).toFixed(2).replace(".00", "") }} Jam</td>
                <td class="text-center" v-else>{{ Number(subItem.qty) % 1 == 0 ? Number(subItem.qty) : Number(subItem.qty).toFixed(2).replace(".00", "") }} Pcs</td>
                <td class="text-center">{{ Number(subItem.harga_jual) }}</td>
                <td class="text-center"><span class="green--text">{{ Number(subItem.discount) % 1 == 0 ? Number(subItem.discount) : Number(subItem.discount).toFixed(2).replace(".00", "") }}%</span></td>
                <td class="text-center"><span class="orange--text">{{ Number(subItem.ppn) % 1 == 0 ? Number(subItem.ppn) : Number(subItem.ppn).toFixed(2).replace(".00", "") }}%</span></td>
                <td class="text-right" v-if="subItem.discount!=0 && subItem.ppn!=0">
                    {{ Number(( ((subItem.qty)*((subItem.harga_jual))) * (1-(subItem.discount/100)) ) * (1+(subItem.ppn/100))) % 1 == 0 ?
                    Number(( ((subItem.qty)*((subItem.harga_jual))) * (1-(subItem.discount/100)) ) * (1+(subItem.ppn/100))) :
                    (( ((subItem.qty)*((subItem.harga_jual))) * (1-(subItem.discount/100)) ) * (1+(Number(subItem.ppn)/100))).toFixed(4).replace(".0000", "") }}
                </td>
                <td class="text-right" v-else-if="subItem.discount!=0">
                    {{ Number(( ((subItem.qty)*((subItem.harga_jual))) * (1-(subItem.discount/100)) )) % 1 == 0 ?
                    Number(( ((subItem.qty)*((subItem.harga_jual))) * (1-(subItem.discount/100)) )) :
                    (((subItem.qty)*((subItem.harga_jual))) * (1-(Number(subItem.discount)/100))).toFixed(4).replace(".0000", "")}}
                </td>
                <td class="text-right" v-else-if="subItem.ppn!=0">
                    {{ Number(( ((subItem.qty)*((subItem.harga_jual))) * (1+(Number(subItem.ppn)/100)) )) % 1 == 0 ? 
                    Number(( ((subItem.qty)*((subItem.harga_jual))) * (1+(Number(subItem.ppn)/100)) )) : 
                    (((subItem.qty)*((subItem.harga_jual))) * (1+(Number(subItem.ppn)/100))).toFixed(4).replace(".0000", "")}}
                </td>
                <td class="text-right" v-else>
                    {{ Number((subItem.qty)*((subItem.harga_jual))) % 1 == 0 ? 
                    Number((subItem.qty)*((subItem.harga_jual))) : 
                    (Number(subItem.qty)*((subItem.harga_jual))).toFixed(4).replace(".0000", "") }}
                </td>
                </tr>
                <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td><h4 class="text-right font-weight-bold">Subtotal:</h4></td>
                <td class="text-right">{{ Number(dataDetails.total) }}</td>
                </tr>
                <tr v-if="paid > 0">
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td><h4 class="text-right font-weight-bold green--text">Dibayar:</h4></td>
                <td class="text-right green--text">{{ Number(paid) }}</td>
                </tr>
                <tr>
                <td colspan="5">
                    <!-- <v-btn
                        class="ma-2"
                        small
                        color="primary"
                        @click="expand = !expand"
                    >
                    <v-icon class="mr-2">history</v-icon> Riwayat Pembayaran
                    </v-btn>
                    <v-btn
                        v-if="role == 'stockiest' && dataDetails.status == 'PAID'"
                        class="ma-2"
                        small
                        color="success"
                        @click="completeSubmission()"
                    >
                    <v-icon class="mr-2">done</v-icon> Order Selesai
                    </v-btn> -->
                </td>
                <td v-if="dataDetails.total - paid > 0 && paid > 0"><h4 class=" text-right font-weight-bold">Total:</h4></td>
                <td v-if="dataDetails.total - paid > 0 && paid > 0" class="text-right">{{ dataDetails.total - paid }}</td>
                </tr>
            </tbody>
          </template>
        </v-simple-table>
        <template v-if="paymentItems != null">
          <p class="text-center font-weight-bold" style="margin: 10px 0px">RIWAYAT PEMBAYARAN</p>
          <v-divider></v-divider>
          <v-simple-table fixed-header class="mb-4 mt-2">
              <template>
              <thead class="grey lighten-4">
                  <tr>
                    <td v-for="header in headerPaymentHistory" :key="header.text">{{ header.text }}</td>
                  </tr>
              </thead>
              <tbody v-if=" paymentItems != null">
                  <tr v-for="(subItem, index2) in paymentItems" :key="subItem.id">
                  <!-- <td>{{ new Date(subItem.tanggal).toLocaleDateString('id') }}</td> -->
                    <td class="text-left"><b>{{ index2+1 }}.</b></td>
                    <td>{{ subItem.tanggal }}</td>
                    <td>{{ Number(subItem.jumlah) }}</td>
                    <td>{{ subItem.payment_methods ? subItem.payment_methods.name : '-' }}</td>
                  </tr>
              </tbody>
              <tbody v-else>
                  <tr>
                    <td colspan="4"><p class="text-center font-weight-bold">Tidak ada riwayat pembayaran.</p></td>
                  </tr>
                  <!-- <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td><p class="font-weight-bold">Total</p></td>
                  <td><p>{{ dataDetails.total }}</p></td>
                  </tr> -->
              </tbody>
              </template>
          </v-simple-table>
          <v-divider></v-divider>
        </template>
        <div class="text-right mt-6">
          <QRCanvas :options="options" />
          <p class="font-weight-bold font-italic subheading">SCAN HERE!</p>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import isEmpty from "lodash/isEmpty";
import { QRCanvas } from 'qrcanvas-vue';
export default {
  name: "DialogOrder",
  components: {
      QRCanvas,
  },
  data: () => ({
      total: 0,
      role: null,
      valid: true,
      headerSubItem: [
          { text: "No.", align: 'text-left'},
          { text: "Nama Item", align: 'text-left'},
          { text: "Jumlah", align: 'text-center'},
          { text: "Harga", align: 'text-center'},
          { text: "Diskon", align: 'text-center'},
          { text: "PPN", align: 'text-center'},
          { text: "Total Harga", align: 'text-right'}
      ],
      headerPaymentHistory: [
          { text: "No."},
          { text: "Tanggal"},
          { text: "Jumlah"},
          { text: "Metode Pembayaran",  align: 'text-right'}
      ],
      paymentMethod: ["Bank Transfer", "Cash"],
      jumlahPayment: 0,
      paymentMethodSelected: "",
      paymentDate: "",
      expand: false,
      dialogPayment: false,
      showError: false,
      cell: 4,
      dataQR: 'Order'
  }),
  computed: {
      ...mapState({
          dialogOrder: state => state.pesanan.dialogOrder,
          idDialogOrder: state => state.pesanan.idDialogOrder,
          dataUser: state => state.pesanan.dataUser,
          dataDetails: state => state.pesanan.dataDetails,
          paymentItems: state => state.pesanan.paymentItems,
          paid: state => state.pesanan.paid
      }),
      options() {
          return {
              cellSize: this.cell,
              correctLevel: 'M',
              data: this.dataQR,
          };
      },
  },

  mounted() {
    this.initialize()
  },

  methods: {
    ...mapMutations({
        showSnackbar: "showSnackbar",
        showLoading: "showLoading",
        closeLoading: "closeLoading",
        setDialogOrder: "pesanan/SET_DIALOG_ORDER",
        setIdDialogOrder: "pesanan/SET_ID_DIALOG_ORDER",
        setDataDetails: "pesanan/SET_DATA_DETAILS",
		    setPaymentItems: "pesanan/SET_PAYMENT_ITEMS",
        setPaid: "pesanan/SET_PAID",
        setListOrder : "pesanan/SET_LIST_ORDER"
    }),
    ...mapActions({
        updateStatusPesanan: "pesanan/updateStatusPesanan",
        detailOrder: "pesanan/detailOrder",
        getTransaction: "transaction/getTransactionBySubmissionId",
        createTransaction: "transaction/createTransaction",
        deleteTransaction: "transaction/deleteTransaction",
        getPesanans: "pesanan/getPesanans",
    }),
    async initialize() {
      this.role = window.localStorage.getItem('user_role')
      await this.setIdDialogOrder(this.$route.params.id)
      await this.detailOrder()
      this.dataQR = 'SUBMISSION_ID:' + this.$route.params.id + ';TYPE:ORDER';

      window.print()
    }
  }
};
</script>
<style>
/* @media print {
  body * {
    background: white!important;
  }
} */
</style>